const {ServiceStatus} = require('@yandex-data-ui/cloud-schemas/build/models/ui-api');
const {SERVICES_PREFIX, SOLUTIONS_PREFIX} = require('../constants');

function addPrefix({name, serviceId, solutionId}) {
    let prefix = '';

    if (serviceId) {
        prefix = SERVICES_PREFIX;
    } else if (solutionId) {
        prefix = SOLUTIONS_PREFIX;
    }

    return `${prefix}${name}`;
}

function removePrefix(pageName) {
    const prefixRe = new RegExp(`(${SERVICES_PREFIX}|${SOLUTIONS_PREFIX})`);

    return pageName.replace(prefixRe, '');
}

function getAllowedStatuses(hasStaffLogin, isIndex) {
    let fullStatuses = Object.values(ServiceStatus);

    if (isIndex) {
        fullStatuses = fullStatuses.filter((status) => status !== ServiceStatus.TechPreview);
    }

    return hasStaffLogin
        ? fullStatuses
        : fullStatuses.filter((status) => status !== ServiceStatus.Develop);
}

module.exports = {
    addPrefix,
    removePrefix,
    getAllowedStatuses,
    SOLUTIONS_PREFIX,
};
